import "./SearchView.css";

import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import ReCaptcha from 'react-google-recaptcha'
import CustomInput from "../../CustomInput/CustomInput";
import ReactLoading from "react-loading";
import { SearchBy } from "../../../models/fineModels";
import { setSearchBy } from "../../../store/fine/fineActions";
import React, {useEffect, useRef} from "react";
import { useState } from "react";
import appConfig from "../../../config";
import axios from "axios";
import { useMaintenanceHook } from "../../../hooks/maintenanceHook";


interface SearchByViewProps {
  infringementNumber: string | null;
  setInfringementNumber: (infringement: string) => void;
  loading: boolean;
  errorMessage: string | null;
  onContinueClicked: (token: string, version: boolean) => Promise<void>
}

const SearchView = ({
  infringementNumber,
  setInfringementNumber,
  loading,
  errorMessage,
  onContinueClicked,
}: SearchByViewProps) => {
  const searchBy = useAppSelector((state) => state.fine.searchBy);
  const idFines = useAppSelector((state) => state.fine.idFines);
  const searchedID = useAppSelector((state) => state.fine.searchedID);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [visibleToken, setVisibleToken] = useState<any>(false);

  const dispatch = useAppDispatch();
  const captchaRef = useRef<any>(null);
  const [numberTries, setNumberTries] = useState(1)
  const { isMaintenance } = useMaintenanceHook();


  useEffect(() => {
    if (searchBy === SearchBy.ID_NUMBER) {
      if (idFines) {
        if (infringementNumber === searchedID) {
          setDisabled(true);
        } else {
          setDisabled(false);
        }
      }
    }
  }, [infringementNumber, idFines, searchedID]);

  const APIKEY = numberTries % 3 !== 0 ? appConfig.recaptchaSiteKey : appConfig.recpatchaSiteKeyv2;

  const handleVerification = async (token: string, ) => {
    const url = `${appConfig.baseApiUrl}/api/verify-recaptcha`;

    return axios.post(url, {recaptchaToken: token, version: numberTries % 3 !== 0})
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error(error);
          return false;
        });

  };
  const handleExecuteRecaptcha = async (submitted = true) => {
    let token: string;

    if (captchaRef.current != null) {
      if (submitted) {
        token = await captchaRef.current?.executeAsync();
      } else {
        token = await captchaRef.current.getValue();

      }

      setNumberTries(numberTries + 1)
      setDisabled(false)
    if (submitted) {
      await onContinueClicked(token, (numberTries) % 3 !== 0)
    } else {
      setVisibleToken({token, version:(numberTries) % 3 !== 0})
    }
      //  if (verify.success) {

    //    !loading && onContinueClicked()
    //  }


    }
  }


  return (
    <>
      <div className="search-view-heading">
        {searchBy === SearchBy.ID_NUMBER ? (
          <p>Search fines by ID Number</p>
        ) : (
          <p>Search fines by Traffic Notice Number</p>
        )}
        <p
          className="change-button"
          onClick={() => dispatch(setSearchBy(null))}
        >
          Change
        </p>
      </div>

      <CustomInput
        maxLength={36}
        disabled={isMaintenance}
        placeholder={
          searchBy === SearchBy.ID_NUMBER
            ? "ID Number"
            : "Traffic Notice Number"
        }
        containerStyle={{
          width: "auto",
          minwidth: "85%",
          maxWidth: "85%",
        }}
        setValue={setInfringementNumber}
        value={infringementNumber}
        onKeyPress={(event)  => {
          if (event.key === "Enter" && !loading) {
            setDisabled(true)
             handleExecuteRecaptcha(true);
          }
        }}
        error={!loading && errorMessage ? errorMessage : ""}
      />

      <div
        className="continue-button"
        onClick={() => {
          if (!isMaintenance) {
            setDisabled(true)
            if (!loading && !disabled) handleExecuteRecaptcha(true);
          } else if (!visibleToken) {
            if (!loading && !disabled) handleExecuteRecaptcha(true);
          } else {
            if (!loading && !disabled) onContinueClicked(visibleToken.token, visibleToken.version)
            setVisibleToken(false)
            setDisabled(false)

          }
        }}
        style={{
          cursor: disabled || isMaintenance ? "inherit" : "pointer",
          opacity: disabled || isMaintenance ? 0.5 : 1,
        }}
      >
        {!loading ? (
          "Continue"
        ) : (
          <ReactLoading
            type="bubbles"
            color="white"
            height={"50%"}
            width={"20%"}
          />
        )}
      </div>
      {numberTries % 3 !== 0 ? (<>
        <ReCaptcha
            theme="light"
            size={"invisible"}
            ref={captchaRef}
            sitekey={APIKEY}
        />
      </>) : (
          <ReCaptcha
              size={"normal"}
              ref={captchaRef}
              style={{marginTop: 10}}
              sitekey={APIKEY}
              onChange={(e: any) => handleExecuteRecaptcha(false)}
          />
      )}
    </>
  );
};

export default SearchView;
